module.exports = __webpack_public_path__ + "product_search_commission-75a3f8cb251f1c172de4cd7c7c663077.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/common/onboarding/product_search_commission.png
// module id = 1186
// module chunks = 2 3 4 5 6